import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=4270c76b"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports